import  ActiveHeaderType from './activeheader.type';
export const setActiveHeader = data =>({
    type: ActiveHeaderType.SET_ACTIVE_HEADER,
    payload: data
})